import { Type } from '@angular/core';
import { DropOffBaseStep, ValidateBookingActionBaseComponent } from '@luggagehero/features/bookings';

import {
  DropOffActionComponent,
  ExplainStorageTimerActionComponent,
  SelectPaymentMethodActionComponent,
  ValidateBookingActionComponent,
} from '../booking-actions';

export class DropOffStep extends DropOffBaseStep {
  protected get dropOffActionComponentType(): Type<DropOffActionComponent> {
    return DropOffActionComponent;
  }

  protected get selectPaymentMethodActionComponentType(): Type<SelectPaymentMethodActionComponent> {
    return SelectPaymentMethodActionComponent;
  }

  protected get explainStorageTimerActionComponentType(): Type<ExplainStorageTimerActionComponent> {
    return ExplainStorageTimerActionComponent;
  }

  protected get validateBookingActionComponentType(): Type<ValidateBookingActionBaseComponent> {
    return ValidateBookingActionComponent;
  }
}
